/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Sendmessage1Inputs */

const he_contact_sendmessage1 = /** @type {(inputs: Contact_Sendmessage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שלח הודעה`)
};

const en_contact_sendmessage1 = /** @type {(inputs: Contact_Sendmessage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send a Message`)
};

/**
* | output |
* | --- |
* | "Send a Message" |
*
* @param {Contact_Sendmessage1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_sendmessage1 = /** @type {((inputs?: Contact_Sendmessage1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Sendmessage1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_sendmessage1(inputs)
	return en_contact_sendmessage1(inputs)
});
export { contact_sendmessage1 as "contact_sendMessage" }